<template>
  <v-flex xs12>
    <v-card v-if="this.lessons.length !== 0" class="pa-2">
      <v-toolbar v-if="this.lessons[0].studentId !== this.$store.state.adminId" color="blue-grey lighten-5 mb-3">
        <v-toolbar-title class="ml-0 tle">Upcoming lessons</v-toolbar-title>
        <v-btn small class="newEntry secondary" @click="$router.push('/lessons')">Reserve a lesson</v-btn>
      </v-toolbar>
      <v-toolbar v-else color="blue-grey lighten-5 mb-2">
        <v-toolbar-title>Upcoming lessons</v-toolbar-title>
      </v-toolbar>
      <div v-for="(lesson, index) in lessons" :key="index" v-ripple>
        <span class="entryHeader">
          <p class="tle">{{lesson.date | formatDateFull}} - {{lesson.lessonTime}} </p>
          <div v-show="lessons[0].studentId !== $store.state.adminId">
            <a href="javascript:;" class="ml-5 mr-3" @click="del(lesson)">cancel</a>
          </div>
        </span>
        <v-divider v-show="index + 1 < lessons.length" class="mb-1 mt-1"></v-divider>
      </div>

    </v-card>
    <v-card v-else>
      <v-container>
      You currently have no scheduled voice lessons scheduled.
      <v-btn small class="newEntry primary" @click="$router.push('/lessons')">Reserve a voice lesson</v-btn>
      </v-container>

    </v-card>
  </v-flex>
</template>

<script>
import { addDays, addMonths, format } from "date-fns"
import { sortByDate } from '../mixins/utilities.js'
import isWithinRange from "date-fns/is_within_range"
export default {
  created() {
    this.lessons.length === 0 ? this.$router.push('/lessons') : ""
  },
  data() {
    return {
      getLastMonth: false
    };
  },
  computed: {
    lessons() {
      let twoMonthsFromNow = addMonths(new Date(), 2)
      let oneWeekAgo = addDays(new Date(), -1)
      let arrLessons = this.$store.getters.getStudentLessons.filter(el => {
        return isWithinRange(el.date, oneWeekAgo, twoMonthsFromNow)
      })
      return sortByDate(arrLessons, 'date')
    },
    user() {
      return this.$store.state.user.fname + " " + this.$store.state.user.lname
    }
  },
  methods: {
    del(objLesson) {
      if (confirm("Delete this lesson?")) {
        const objData = {
          service_id: 'gmail',
          template_id: 'lesson_cancellation',
          user_id: this.$store.state.emailJSId,
          template_params: {
            'studentName': this.user,
            'lessonDate': this.parseDate(objLesson.date),
            'lessonTime': objLesson.lessonTime,
            'timestamp': format(new Date(), 'ddd. MMM. D, YYYY h:mm A')
          }
        }
        objLesson.data = objData
        this.$store.dispatch("deleteLesson", objLesson);
      }
    },
    parseDate(strDate) {
      let strYear = strDate.substring(0, 4)
      let strMonth = strDate.substring(5,7)
      let strDay = strDate.substring(8,10)
      let strNewDate = format(new Date(strYear, strMonth-1, strDay),'ddd. MMM. D, YYYY')
      return strNewDate
    }
  }
};
</script>

<style scoped>
p {
  font-size: 0.9rem;
  padding: 5px;
  margin-bottom: 0;
}

.tle {
  font-size: .95rem;
  font-weight: 500;
  padding: 5px;
}

.newEntry {
  margin-left: 30px;
  font-size: .8rem;
}

a {
  color: #3d3d3d;
}

.entryHeader {
  display: inline-flex;
  align-items: baseline;
}
</style>